import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import Utilities from '@/Utility/Utilities';

export default class NumericColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;
    public floatingPrecision: number;

    constructor(params: any) {
        super(params);
        this.floatingPrecision = this.paramOrDefault(params.floatingPrecision, null);
    }

    public getValue(): HTMLElement {
        let number = Utilities.toLocaleNumber(this.raw, this.floatingPrecision);
        if (Utilities.isBlank(number)) {
            number = '-';
        }

        let div = document.createElement('div');
        div.style.textAlign = 'right';
        div.textContent = number;

        return div;
    }
}

ComponentManager.setFactory('NumericColumn', NumericColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');